var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSearch = function SvgSearch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5576 10.4336C10.7956 10.2031 11.1755 10.2092 11.406 10.4472L14.7654 13.916C14.9959 14.154 14.9898 14.5339 14.7518 14.7644C14.5138 14.9949 14.1339 14.9889 13.9034 14.7508L10.544 11.2821C10.3135 11.044 10.3195 10.6642 10.5576 10.4336Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.06836 7.00141C1.06836 3.7236 3.72555 1.06641 7.00336 1.06641C10.2812 1.06641 12.9384 3.7236 12.9384 7.00141C12.9384 10.2792 10.2812 12.9364 7.00336 12.9364C3.72555 12.9364 1.06836 10.2792 1.06836 7.00141ZM7.00336 2.26641C4.38829 2.26641 2.26836 4.38634 2.26836 7.00141C2.26836 9.61647 4.38829 11.7364 7.00336 11.7364C9.61843 11.7364 11.7384 9.61647 11.7384 7.00141C11.7384 4.38634 9.61843 2.26641 7.00336 2.26641Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "search.2cba1862aefd56c3d52b3428826ddd0e.svg";